// Form表单模型
class FormModel {
  public label?: string;
  public value?: string;
  public placeholder?: string;
  public type?: string;
  public modelName?: string;
  public field?: string;
  public extField1?: string;
  public extField2?: string;
  public extField3?: string;
  public extField4?: string;
  public extField5?: string;
  public extFieldValue1?: any;
  public extFieldValue2?: any;
  public extFieldValue3?: any;
  public extFieldValue4?: any;
  public extFieldValue5?: any;
  public onChange?: any;
  public width?: number;
  public getRef?: any;
  public currentRef?: any;

  constructor() {
    this.label = "";
    this.value = "";
    this.placeholder = "";
    this.type = "";
    this.modelName = "";
    this.field = "";
    this.extField1 = "";
    this.extField2 = "";
    this.extField3 = "";
    this.extField4 = "";
    this.extField5 = "";
    this.extFieldValue1 = "";
    this.extFieldValue2 = "";
    this.extFieldValue3 = "";
    this.extFieldValue4 = "";
    this.extFieldValue5 = "";
    this.onChange = null;
    this.width = 100;
  }
}

export default FormModel;
